import React from "react";
import "./Creative_ways_cards.css";
import Like_heart_btn_holder from "../Like_heart_btn_holder/Like_heart_btn_holder";
import HeartIconComponent from "../HeartIconComponent/HeartIconComponent";

function Creative_ways_cards({ anotherClass }) {
  return (
    <>
      <section className={`Creative_ways_cards ${anotherClass}`}>
        <div className="Shop_by_shapes_cards_heart">
          <div className="shapes_cards_img_holder">
            <img
              src={
                process.env.PUBLIC_URL +
                "/assets/Images/Visiting_Cards/Shapes_cards/shapes_cards_img_1.png"
              }
              className="shapes_cards_img"
              alt="shapes_cards_img"
            />
          </div>

          <div className="Heart_btn">
            <HeartIconComponent />
          </div>

          <div className="text_holder">
            <h4>Standard</h4>
          </div>

          <div className="overlay_holder"></div>
        </div>
      </section>
    </>
  );
}

export default Creative_ways_cards;
